<div class="row">
  <div class="col-sm mb-2">
    <label for="resultsPerPage" class="pr-1">
      Results per page:
    </label>
    <select id="resultsPerPage"
            class="custom-select custom-select-sm d-inline-block"
            style="width:64px;"
            [(ngModel)]="pageSize"
            (ngModelChange)="pageSizeChange.emit(pageSize); pageNumChange.emit(1); reloadSubject.next();">
      <option [ngValue]="10">10</option>
      <option [ngValue]="25">25</option>
      <option [ngValue]="50">50</option>
      <option [ngValue]="100">100</option>
    </select>
  </div>
  <div class="col-sm">
    <nav aria-label="Pagination">
      <ul class="pagination pagination-sm justify-content-end">
        <li class="page-item"
            [class.disabled]="pageNum <= 1">
          <button class="page-link" aria-label="Previous"
                  [disabled]="pageNum <= 1"
                  (click)="pageNumChange.emit(pageNum - 1); reloadSubject.next();">
            <span aria-hidden="true">&laquo;</span>
          </button>
        </li>
        <li class="page-item"
            *ngIf="pageNum > 2">
          <button class="page-link"
                  (click)="pageNumChange.emit(pageNum - 2); reloadSubject.next();">
            {{ pageNum - 2 }}
          </button>
        </li>
        <li class="page-item"
            *ngIf="pageNum > 1">
          <button class="page-link"
                  (click)="pageNumChange.emit(pageNum - 1); reloadSubject.next();">
            {{ pageNum - 1 }}
          </button>
        </li>
        <li class="page-item active" aria-current="page">
          <button class="page-link" disabled>
            {{ pageNum }}
            <span class="sr-only">(current)</span>
          </button>
        </li>
        <li class="page-item"
            *ngIf="pageNum < lastPageNum">
          <button class="page-link"
                  (click)="pageNumChange.emit(pageNum + 1); reloadSubject.next();">
            {{ pageNum + 1 }}
          </button>
        </li>
        <li class="page-item"
            *ngIf="pageNum < (lastPageNum - 1)">
          <button class="page-link"
                  (click)="pageNumChange.emit(pageNum + 2); reloadSubject.next();">
            {{ pageNum + 2 }}
          </button>
        </li>
        <li class="page-item"
            [class.disabled]="pageNum >= lastPageNum">
          <button class="page-link" aria-label="Next"
                  [disabled]="pageNum >= lastPageNum"
             (click)="pageNumChange.emit(pageNum + 1); reloadSubject.next();">
            <span aria-hidden="true">&raquo;</span>
          </button>
        </li>
      </ul>
    </nav>
  </div>
</div>
